"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropLocationStore = exports.DropLocationType = void 0;
var mobx_1 = require("mobx");
var DropLocationType;
(function (DropLocationType) {
    DropLocationType["BetweenBlocks"] = "droplocationtype:betweenblocks";
    DropLocationType["TwoColumnPlaceholder"] = "droplocationtype:twocolumnplaceholder";
})(DropLocationType || (exports.DropLocationType = DropLocationType = {}));
var DropLocationStore = (function () {
    function DropLocationStore() {
    }
    Object.defineProperty(DropLocationStore.prototype, "dropLocation", {
        get: function () {
            return this.location;
        },
        enumerable: false,
        configurable: true
    });
    DropLocationStore.prototype.setDropLocation = function (location) {
        this.location = location;
    };
    DropLocationStore.prototype.clearDropLocation = function () {
        this.location = undefined;
    };
    __decorate([
        mobx_1.observable.struct,
        __metadata("design:type", Object)
    ], DropLocationStore.prototype, "location", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], DropLocationStore.prototype, "dropLocation", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DropLocationStore.prototype, "setDropLocation", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DropLocationStore.prototype, "clearDropLocation", null);
    return DropLocationStore;
}());
exports.DropLocationStore = DropLocationStore;
